<template>
  <v-main>
    <v-layout fill-height column align-center justify-center>
      <v-container class="error-container">
        <div class="guide">
          <v-img :src="getImage(guideInfo.question)" max-width="100px" class="mx-auto mb-3" />
        </div>
        <h2>세션이 만료되었습니다.</h2>
        <p>
          세션 유효기간이 초과되어 연결이 종료되었습니다.<br />
          {{ appText }} 이동하셔서 다시 접속해주세요.
        </p>
        <v-btn elevation="0" min-width="140px" color="primary" class="mt-5">
          <span class="fs-14" @click="sendRoute()">다시 시도</span>
        </v-btn>
      </v-container>
    </v-layout>
  </v-main>
</template>

<script>
import {mixinRemote} from "@/mixins";
import store from "@/store";

export default {
  name: 'Expired',
  components: {},
  mixins: [mixinRemote],
  props: {},
  data: () => ({
    anifitUrl: 'https://anyfitpro.samsungfire.com/hb/page/NPGEHBC10101.do'
  }),
  computed: {
    appText () {
      if (this.isSamsungFire) {
        return "Anifit-Pro App으로"
      }
      return "WHOYOU로";
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    sendRoute () {
      if (this.isSamsungFire) {
        window.open(store.state.auth.anifitProUrl || this.anifitUrl)
      } else {
        window.location.href = '/user/login'
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.error-container {
  padding-bottom: 60px;
  text-align: center;
  color: #999;
  h2 {
    margin-bottom: 5px;
    font-weight: 600;
    font-size: 18px;
    color: #333;
  }
}
</style>
